var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyCookieBlocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.917,
    d: "M32.343 3.75 6.297 34.929h23.442l-2.605 20.785 26.047-31.178H29.739L32.343 3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyCookieBlocker);
export default __webpack_public_path__ + "static/media/privacy-cookie-blocker.2b7bba3bf83eb7320a983358c60c2fad.svg";
export { ForwardRef as ReactComponent };